export default {
  install(Vue, options) {
    const store = options.store;
    let request;

    Vue.mixin({
      data() {
        return {
          globalData: {
            isDownloading: false
          }
        };
      }
    });

    const downloadFile = (blob, metadata) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      // works in IE11
      if (typeof window.navigator.msSaveBlob === "function") {
        window.navigator.msSaveBlob(blob, metadata.name);
      } else {
        link.setAttribute("download", metadata.name);
        document.body.appendChild(link);
        link.click();
      }
    };

    const getMetaData = async (documentId, entityUri) => {
      const axios = require("axios");
      const api = store.state.config.configurationData;
      const result = await axios
        .post(
          `${api.apiBaseUrl}/aceas/api/internet/doc/v1/metadata/get-one`,
          {
            documentId: documentId,
            entityUri: entityUri
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.auth.accessToken}`
            }
          }
        )
        .then(response => {
          if (response.data.status === 200) {
            return response.data.data;
          } else if (response.data.status === 401) {
            store.commit("auth/setIsSessionActive", false);
          } else {
            throw new Error("Failed to get file's metadata");
          }
        });

      return result;
    };

    Vue.prototype.$_globalMixin_uploadSmallFile = async function(
      file,
      additionalProperties
    ) {
      // return {
      //   documentId: "29292992",
      //   name: file.name
      // };

      const axios = require("axios");

      const axiosSource = axios.CancelToken.source();
      request = { cancel: axiosSource.cancel };

      let formData = new FormData();
      formData.append("file", file, file.name);

      if (additionalProperties)
        formData.append(
          "additionalProperties",
          new Blob([JSON.stringify({ ...additionalProperties })], {
            type: "application/json"
          })
        );

      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${store.state.auth.accessToken}`
      };

      const api = store.state.config.configurationData;
      const uploadResponse = await axios
        .post(
          `${api.apiBaseUrl}/aceas/api/internet/doc/v1/file/upload-small`,
          formData,
          {
            headers: headers,
            cancelToken: axiosSource.token
          }
        )
        .then(response => {
          if (response.data.status === 200) {
            return response;
          } else if (response.data.status === 401) {
            store.commit("auth/setIsSessionActive", false);
          } else {
            throw new Error(response.data.data);
          }
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            if (error.response.status === 401) {
              store.commit("auth/setIsSessionActive", false);
            }
            throw new Error(error.message);
          } else {
            throw new Error("Upload cancelled");
          }
        });

      return uploadResponse;
    };

    Vue.prototype.$_globalMixin_cancelUpload = function() {
      request.cancel();
      this.$_globalMixin_clearRequest();
    };

    Vue.prototype.$_globalMixin_clearRequest = function() {
      request = null;
    };

    Vue.prototype.$_globalMixin_downloadUsingPresignedUrl = async function(
      documentId,
      entityUri = this.$route.meta.entityUri
    ) {
      const axios = require("axios");
      this.globalData.isDownloading = true;
      const api = store.state.config.configurationData;
      await axios
        .post(
          `${api.apiBaseUrl}/aceas/api/internet/doc/v1/file/download`,
          {
            documentId: documentId,
            entityUri: entityUri
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.auth.accessToken}`
            },
            responseType: "blob"
          }
        )
        .then(async response => {
          if (response.status === 200) {
            this.globalData.isDownloading = false;
            const metaData = await getMetaData(documentId, entityUri);
            downloadFile(response.data, metaData);
          } else if (response.data.status === 401) {
            store.commit("auth/setIsSessionActive", false);
          } else {
            throw new Error(response.data.data);
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            store.commit("auth/setIsSessionActive", false);
          } else {
            this.$buefy.dialog.alert({
              message: error.message,
              type: "is-danger",
              hasIcon: true,
              icon: "times",
              iconPack: "fa"
            });
          }

          this.globalData.isDownloading = false;
        });
    };
  }
};
